import React, { ReactNode } from 'react';

import './tooltip.scss';

export type TooltipPosition = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

export interface TooltipProps {
    message: string;
    position?: TooltipPosition;
    children: ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ message, position = 'top-right', children }) => (
    <span className="tooltip-wrapper">
        <span className={`tooltip tooltip--${position}`}>
            {message}
        </span>
        {children}
    </span>
);

export default Tooltip;
